<template>
  <div id="wrapper">
    <SectionHeader
      :text="$t('media.mediaAppearances')"
      :back-text="$t('media.mediaAppearancesBack')"
    />
    <transition tag="div">
      <Loading v-if="!data" />
      <div
        class="media-appearance-wrapper"
        v-if="data"
        v-masonry
        transition-duration="0.3s"
        item-selector=".item"
      >
        <div v-masonry-tile class="item" v-for="item in data" :key="item.id">
          <img :src="item.thumbnail" />
          <h3>{{ item.title }}</h3>
          <div>{{ item.short_text }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SectionHeader from "../SectionHeader";
import Loading from "../Loading";

export default {
  name: "MediaAppearances",
  components: { Loading, SectionHeader },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http
      .get("media-appearances/")
      .then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.item {
  width: calc(33.3333% - 30px);
  border: 1px solid #dadada;
  padding: 20px 20px 36px;
  color: black;
  margin: 0 15px 40px;
}

.item:hover {
  background: black;
  color: white;
}

.item h3 {
  margin-top: 43px;
  margin-bottom: 30px;
  font-size: 1.6em;
  line-height: 1.2em;
  min-height: 3.6em;
}

.item div {
  color: #a0a0a0;
  font-size: 1.2em;
  font-weight: 300;
}

@media (max-width: 991px) {
  .item {
    width: calc(50% - 30px);
  }
}

@media (max-width: 479px) {
  .item {
    width: calc(100% - 30px);
  }
}
</style>
